// Rich SEO content per course detail page

export const COURSE_PAGES = {
  automaquillaje: {
    backend_slug: "automaquillaje",
    hero_image: "https://images.unsplash.com/photo-1679141335715-18e7c98486e3?crop=entropy&cs=srgb&fm=jpg&q=85",
    gallery_category: "courses",
    eyebrow: { es: "Curso · Automaquillaje", en: "Course · Self-Makeup", jp: "コース · セルフメイク" },
    title: {
      es: "Maquíllate como si te maquillara una profesional.",
      en: "Do your own makeup like a pro would do it.",
      jp: "プロが施すような仕上がりを、自分で。",
    },
    intro: {
      es: "Un curso intensivo de un día para mujeres que quieren dominar su propio rostro. Aprende las técnicas que uso con mis clientas editoriales y novias, adaptadas a tu vida diaria.",
      en: "An intensive one-day course for women who want to master their own face. Learn the techniques I use with my editorial clients and brides, adapted for daily life.",
      jp: "ご自身の顔をマスターしたい方のための1日集中講座。エディトリアルやブライダルのクライアントに使うテクニックを、日常に落とし込みます。",
    },
    seo_title: {
      es: "Curso de Automaquillaje Profesional en Aguascalientes · Abril Suarez",
      en: "Professional Self-Makeup Course · Aguascalientes · Abril Suarez",
      jp: "セルフメイク講座 アグアスカリエンテス · アブリル・スアレス",
    },
    seo_desc: {
      es: "Curso de automaquillaje profesional en Aguascalientes. Un día intensivo, técnicas de larga duración, productos de alta gama. Para mujeres reales que quieren verse impecables a diario.",
      en: "Professional self-makeup course in Aguascalientes. One intensive day, long-lasting techniques, high-end products. For real women who want to look impeccable daily.",
      jp: "アグアスカリエンテスでのプロフェッショナル・セルフメイク講座。1日集中、長持ちテクニック、高級プロダクト。",
    },
    audience: {
      es: ["Mujeres que quieren maquillarse mejor a diario", "Personas con eventos importantes próximos (boda, graduación)", "Profesionales que necesitan verse pulidas en cámara", "Quienes invierten en buenos productos pero no saben aprovecharlos"],
      en: ["Women who want to do better daily makeup", "People with upcoming important events (wedding, graduation)", "Professionals who need to look polished on camera", "Those who invest in good products but don't know how to use them"],
      jp: ["毎日のメイクをアップグレードしたい方", "結婚式・卒業式など大切な予定がある方", "カメラ映りを良くしたいプロフェッショナル", "良い化粧品を持っているが使いこなせない方"],
    },
    curriculum: {
      es: [
        { t: "Análisis de rostro", d: "Identifica tu forma de rostro, ojos y tono de piel. Productos correctos para ti." },
        { t: "Skincare como base", d: "La piel preparada es 70% del resultado. Rutina express antes del maquillaje." },
        { t: "Piel impecable", d: "Primer, base, corrector, contorno. Técnicas para que el maquillaje dure 10+ horas." },
        { t: "Mirada de impacto", d: "Cejas, sombras, delineado y pestañas. Tres looks: día, oficina y noche." },
        { t: "Labios duraderos", d: "Técnicas para que el labial sobreviva café, comida y conversaciones." },
        { t: "Sello final", d: "Fijación, polvos, brumas y retoques. Tu kit esencial y por qué." },
      ],
      en: [
        { t: "Face analysis", d: "Identify your face shape, eyes and skin tone. The right products for you." },
        { t: "Skincare as a base", d: "Prepared skin is 70% of the result. Express routine before makeup." },
        { t: "Impeccable skin", d: "Primer, foundation, concealer, contour. Techniques to make makeup last 10+ hours." },
        { t: "Statement eyes", d: "Brows, shadows, liner and lashes. Three looks: day, office and night." },
        { t: "Long-lasting lips", d: "Techniques so lipstick survives coffee, food and conversations." },
        { t: "Final seal", d: "Setting, powders, mists and touch-ups. Your essential kit and why." },
      ],
      jp: [
        { t: "顔分析", d: "顔の形、目、肌のトーンを分析し、あなたに合う製品を見つけます。" },
        { t: "ベースとしてのスキンケア", d: "整った肌が結果の70%。メイク前のエクスプレスルーティン。" },
        { t: "完璧な肌", d: "プライマー、ファンデ、コンシーラー、コントゥア。10時間以上持続するテクニック。" },
        { t: "印象的な目元", d: "眉、シャドウ、ライナー、まつげ。デイ／オフィス／ナイトの3ルック。" },
        { t: "長持ちリップ", d: "コーヒー、食事、会話に耐えるリップテクニック。" },
        { t: "仕上げ", d: "セッティング、パウダー、ミスト、タッチアップ。必須キット解説。" },
      ],
    },
    includes: {
      es: ["8 horas de clase con grupo reducido (max 8 personas)", "Material impreso + guía de productos", "Brunch durante la sesión", "Kit de muestras para llevarte", "Constancia de participación", "Acceso a comunidad privada de alumnas"],
      en: ["8 hours of class, small group (max 8 people)", "Printed material + product guide", "Brunch during the session", "Sample kit to take home", "Certificate of participation", "Access to private student community"],
      jp: ["8時間の少人数クラス（最大8名）", "印刷教材＋プロダクトガイド", "セッション中のブランチ", "サンプルキットお持ち帰り", "受講証明書", "受講生限定コミュニティへのアクセス"],
    },
    faq: {
      es: [
        { q: "¿Necesito experiencia previa?", a: "No. El curso está diseñado para principiantes y para quienes ya se maquillan pero quieren elevar su técnica." },
        { q: "¿Tengo que llevar mis productos?", a: "Puedes llevar los que ya tengas — los analizamos en clase. Yo aporto los productos profesionales para que pruebes." },
        { q: "¿Cuánto debo reservar?", a: "Tu lugar se asegura con el 50%. El resto se paga el día del curso." },
        { q: "¿Se entrega certificado?", a: "Sí, constancia de participación firmada al finalizar." },
      ],
      en: [
        { q: "Do I need prior experience?", a: "No. The course is designed for beginners and for those who already do makeup but want to elevate their technique." },
        { q: "Do I have to bring my products?", a: "You can bring what you already have — we analyse them in class. I provide professional products for you to try." },
        { q: "How much is the deposit?", a: "Your spot is secured with 50%. The rest is paid the day of the course." },
        { q: "Do I get a certificate?", a: "Yes, signed certificate of participation at the end." },
      ],
      jp: [
        { q: "経験は必要ですか？", a: "不要です。初心者から、既にメイクをするがテクニックを向上させたい方まで対象です。" },
        { q: "自分の化粧品を持参すべき？", a: "お持ちのものを持参いただければクラスで分析します。プロ製品はこちらで用意します。" },
        { q: "デポジットはいくらですか？", a: "50%でお席を確保します。残りは当日お支払いください。" },
        { q: "修了証はもらえますか？", a: "はい、修了時に署名入り修了証を授与します。" },
      ],
    },
  },

  novias: {
    backend_slug: "novias",
    hero_image: "https://images.pexels.com/photos/16096141/pexels-photo-16096141.png",
    gallery_category: "bridal",
    eyebrow: { es: "Curso · Novias", en: "Course · Bridal", jp: "コース · ブライダル" },
    title: {
      es: "Conviértete en la maquillista que toda novia recomienda.",
      en: "Become the makeup artist every bride recommends.",
      jp: "すべての花嫁が推薦するメイクアップアーティストへ。",
    },
    intro: {
      es: "Curso intensivo de tres días para maquillistas que quieren especializarse en novias. Más allá de la técnica: comunicación con la novia, manejo de pruebas, fotografía y cómo construir un negocio rentable.",
      en: "Three-day intensive course for makeup artists who want to specialise in brides. Beyond technique: bride communication, trial management, photography and how to build a profitable business.",
      jp: "ブライダル特化を目指すメイクアーティスト向けの3日間集中講座。技術だけでなく、新婦とのコミュニケーション、トライアル運営、撮影、収益性あるビジネス構築まで。",
    },
    seo_title: {
      es: "Curso de Maquillaje para Novias en Aguascalientes · Abril Suarez",
      en: "Bridal Makeup Course · Aguascalientes · Abril Suarez",
      jp: "ブライダルメイク講座 アグアスカリエンテス · アブリル・スアレス",
    },
    seo_desc: {
      es: "Curso profesional de maquillaje para novias en Aguascalientes. 3 días intensivos, técnicas de larga duración, fotografía y negocio. Para maquillistas que quieren especializarse en bodas.",
      en: "Professional bridal makeup course in Aguascalientes. 3 intensive days, long-lasting techniques, photography and business. For makeup artists who want to specialise in weddings.",
      jp: "アグアスカリエンテスでのプロフェッショナル・ブライダルメイク講座。3日間集中、長持ち技術、撮影、ビジネス構築。",
    },
    audience: {
      es: ["Maquillistas en formación que quieren especializarse", "Maquillistas con experiencia general buscando entrar al sector novias", "Profesionales que quieren elevar su ticket promedio", "Egresadas de escuelas de maquillaje que necesitan especialización práctica"],
      en: ["Makeup artists in training who want to specialise", "Generalist makeup artists wanting to enter bridal", "Professionals looking to raise their average ticket", "Makeup-school graduates needing practical specialisation"],
      jp: ["特化を目指す研修中のメイクアーティスト", "ブライダル分野に参入したい総合メイクアーティスト", "客単価を上げたいプロフェッショナル", "実践的な専門化が必要なメイクスクール卒業生"],
    },
    curriculum: {
      es: [
        { t: "Día 1 — Piel y diagnóstico", d: "Análisis de piel, prep extensa, base perfecta para fotografía y video. Productos por tipo de piel." },
        { t: "Día 1 — Estilo y moodboards", d: "Cómo leer a tu novia. Construcción de moodboard, paleta y referencias visuales." },
        { t: "Día 2 — Ojos editorial", d: "Cejas, sombras, eyeliner y pestañas para múltiples tipos de ojo. Looks clásico, natural y romántico." },
        { t: "Día 2 — Fotografía", d: "Cómo se ven los productos en cámara: HD, película y video. Pruebas con luz controlada." },
        { t: "Día 3 — Día completo de boda", d: "Simulación de timeline real: prep, novia + 3 invitadas, retoques. Coordinación con fotógrafo." },
        { t: "Día 3 — Negocio", d: "Cotizaciones, contratos, anticipos, redes sociales, branding. Cómo cobrar lo que vales." },
      ],
      en: [
        { t: "Day 1 — Skin & diagnosis", d: "Skin analysis, extensive prep, perfect base for photo and video. Products by skin type." },
        { t: "Day 1 — Style & moodboards", d: "How to read your bride. Building moodboard, palette and visual references." },
        { t: "Day 2 — Editorial eyes", d: "Brows, shadows, liner and lashes for multiple eye types. Classic, natural and romantic looks." },
        { t: "Day 2 — Photography", d: "How products look on camera: HD, film and video. Tests under controlled light." },
        { t: "Day 3 — Full wedding day", d: "Real timeline simulation: prep, bride + 3 guests, touch-ups. Coordination with photographer." },
        { t: "Day 3 — Business", d: "Quotes, contracts, deposits, social media, branding. How to charge what you're worth." },
      ],
      jp: [
        { t: "1日目 — 肌診断", d: "肌分析、徹底的なプレップ、写真・動画向け完璧なベース。肌タイプ別プロダクト。" },
        { t: "1日目 — スタイル＆ムードボード", d: "花嫁の読み解き方。ムードボード、パレット、参考イメージの構築。" },
        { t: "2日目 — エディトリアル・アイ", d: "眉、シャドウ、ライナー、まつげ。クラシック、ナチュラル、ロマンチックのルック。" },
        { t: "2日目 — 撮影", d: "HD、フィルム、ビデオでの製品の見え方。コントロール照明下でのテスト。" },
        { t: "3日目 — フル・ウェディング・デイ", d: "実タイムライン・シミュレーション。新婦＋ゲスト3名＋タッチアップ。フォトグラファーとの連携。" },
        { t: "3日目 — ビジネス", d: "見積り、契約、デポジット、SNS、ブランディング。適正価格の請求方法。" },
      ],
    },
    includes: {
      es: ["24 horas de clase con grupo reducido (max 6 personas)", "Manual impreso + plantillas de contrato y cotización", "Modelo en vivo para el día 3 (boda completa)", "Comidas durante los 3 días", "Constancia profesional", "Asesoría 1-a-1 post-curso (1 mes)", "Acceso a comunidad privada de egresadas"],
      en: ["24 hours of class, small group (max 6 people)", "Printed manual + contract and quote templates", "Live model for day 3 (full wedding)", "Meals during the 3 days", "Professional certificate", "1-on-1 mentorship post-course (1 month)", "Access to private alumni community"],
      jp: ["24時間の少人数クラス（最大6名）", "印刷マニュアル＋契約・見積りテンプレ", "3日目（実ウェディング）の生モデル", "3日間の食事込み", "プロフェッショナル修了証", "受講後1か月の1-on-1メンタリング", "卒業生限定コミュニティへのアクセス"],
    },
    faq: {
      es: [
        { q: "¿Necesito experiencia previa?", a: "Sí, este curso asume conocimientos básicos. Si eres principiante, comienza con el curso de Automaquillaje." },
        { q: "¿Hay modelos para practicar?", a: "Sí, el día 3 hacemos una boda completa simulada con modelos en vivo." },
        { q: "¿Recibo apoyo después del curso?", a: "Sí, un mes de asesoría 1-a-1 vía WhatsApp para tus primeras bodas reales." },
        { q: "¿Cuánto debo reservar?", a: "Tu lugar se asegura con el 50%. El resto se paga al inicio del curso." },
      ],
      en: [
        { q: "Do I need prior experience?", a: "Yes — this course assumes basic knowledge. If you're a beginner, start with the Self-Makeup course." },
        { q: "Are there models to practise on?", a: "Yes, day 3 we run a complete simulated wedding with live models." },
        { q: "Do I get post-course support?", a: "Yes, one month of 1-on-1 mentorship via WhatsApp for your first real weddings." },
        { q: "How much is the deposit?", a: "Your spot is secured with 50%. The rest is paid at course start." },
      ],
      jp: [
        { q: "経験は必要ですか？", a: "基本知識が前提です。初心者の方はセルフメイク講座からスタートしてください。" },
        { q: "練習用モデルはいますか？", a: "はい、3日目に生モデルでフル・ウェディングをシミュレーションします。" },
        { q: "受講後のサポートはありますか？", a: "はい、初の本番ブライダルのために1か月のLINE/WhatsApp 1-on-1メンタリング付き。" },
        { q: "デポジットは？", a: "50%でお席を確保し、残金は開講時にお支払いいただきます。" },
      ],
    },
  },

  editorial: {
    backend_slug: "editorial-course",
    hero_image: "https://images.unsplash.com/photo-1557924760-b14a6d4a4ef3?crop=entropy&cs=srgb&fm=jpg&q=85",
    gallery_category: "editorial",
    eyebrow: { es: "Curso · Editorial", en: "Course · Editorial", jp: "コース · エディトリアル" },
    title: {
      es: "De la inspiración a la portada.",
      en: "From inspiration to the cover.",
      jp: "インスピレーションから表紙まで。",
    },
    intro: {
      es: "Dos días intensivos de maquillaje editorial avanzado. Diseña y ejecuta looks para portadas, campañas y proyectos personales que puedan entrar a tu portafolio.",
      en: "Two intensive days of advanced editorial makeup. Design and execute looks for covers, campaigns and personal projects ready for your portfolio.",
      jp: "上級エディトリアルメイクの2日間集中。表紙、キャンペーン、ポートフォリオに入るプロジェクトの設計と実行。",
    },
    seo_title: {
      es: "Curso de Maquillaje Editorial Avanzado en Aguascalientes · Abril Suarez",
      en: "Advanced Editorial Makeup Course · Aguascalientes · Abril Suarez",
      jp: "上級エディトリアルメイク講座 アグアスカリエンテス · アブリル・スアレス",
    },
    seo_desc: {
      es: "Curso avanzado de maquillaje editorial en Aguascalientes. Diseño de personajes, moodboards, técnicas para fotografía editorial y producción audiovisual.",
      en: "Advanced editorial makeup course in Aguascalientes. Character design, moodboards, techniques for editorial photography and audiovisual production.",
      jp: "アグアスカリエンテスでの上級エディトリアルメイク講座。キャラクターデザイン、ムードボード、エディトリアル撮影技術。",
    },
    audience: {
      es: ["Maquillistas con técnica sólida que buscan diferenciarse", "Profesionales del medio audiovisual y fotografía", "Maquillistas que quieren construir un portafolio editorial", "Quienes ya trabajan en bodas y buscan diversificar"],
      en: ["Makeup artists with solid technique looking to stand out", "Audiovisual and photography professionals", "Makeup artists building an editorial portfolio", "Bridal artists looking to diversify"],
      jp: ["独自性を求める技術ある メイクアーティスト", "映像・写真業界のプロフェッショナル", "エディトリアル・ポートフォリオを構築したい方", "ブライダルから多様化を目指す方"],
    },
    curriculum: {
      es: [
        { t: "Día 1 — Conceptualización", d: "Cómo leer un brief, construcción de moodboard, paletas y referencias culturales." },
        { t: "Día 1 — Texturas y materiales", d: "Gloss, glitter, cristales, pintura corporal. Cuándo cada técnica funciona en cámara." },
        { t: "Día 2 — Set y producción", d: "Pruebas con luz, retoques on-set, comunicación con director creativo." },
        { t: "Día 2 — Foto final", d: "Sesión real con fotógrafa profesional. Te llevas imágenes editables para tu portafolio." },
      ],
      en: [
        { t: "Day 1 — Conceptualisation", d: "How to read a brief, building moodboards, palettes and cultural references." },
        { t: "Day 1 — Textures and materials", d: "Gloss, glitter, crystals, body paint. When each technique works on camera." },
        { t: "Day 2 — Set and production", d: "Light tests, on-set retouching, communicating with the creative director." },
        { t: "Day 2 — Final photoshoot", d: "Real shoot with professional photographer. You leave with editable images for your portfolio." },
      ],
      jp: [
        { t: "1日目 — コンセプト構築", d: "ブリーフの読み解き、ムードボード、パレット、文化的参照の構築。" },
        { t: "1日目 — テクスチャと素材", d: "グロス、グリッター、クリスタル、ボディペイント。カメラ映えする技法。" },
        { t: "2日目 — 現場と制作", d: "照明テスト、オンセットリタッチ、クリエイティブディレクターとの対話。" },
        { t: "2日目 — 本番撮影", d: "プロフォトグラファーとの実撮影。編集可能な画像をポートフォリオ用にお持ち帰り。" },
      ],
    },
    includes: {
      es: ["16 horas de clase con grupo reducido (max 6 personas)", "Material editorial impreso", "Sesión fotográfica final con fotógrafa profesional", "Imágenes editadas para tu portafolio", "Constancia profesional", "Acceso a red de contactos editoriales"],
      en: ["16 hours of class, small group (max 6 people)", "Printed editorial material", "Final photoshoot with professional photographer", "Edited images for your portfolio", "Professional certificate", "Access to editorial network"],
      jp: ["16時間の少人数クラス（最大6名）", "印刷エディトリアル教材", "プロフォトグラファーとの本番撮影", "ポートフォリオ用編集済み画像", "プロフェッショナル修了証", "エディトリアル業界ネットワークへのアクセス"],
    },
    faq: {
      es: [
        { q: "¿A quién va dirigido?", a: "A maquillistas con técnica sólida que buscan elevar su portafolio o diversificar hacia el sector editorial." },
        { q: "¿Las fotos las puedo usar?", a: "Sí, recibes imágenes editadas con crédito para tu portafolio. Hay licencia de uso editorial y comercial limitado." },
        { q: "¿Se requiere kit propio?", a: "Sí, kit profesional básico. Yo aporto productos especiales (cristales, pinturas, etc.)." },
      ],
      en: [
        { q: "Who is it for?", a: "For makeup artists with solid technique who want to elevate their portfolio or diversify into editorial." },
        { q: "Can I use the photos?", a: "Yes, you receive edited images with credit for your portfolio. Limited editorial and commercial use license included." },
        { q: "Do I need my own kit?", a: "Yes, a basic professional kit. I provide special products (crystals, paints, etc.)." },
      ],
      jp: [
        { q: "対象は？", a: "ポートフォリオを高めたい、またはエディトリアル分野に多様化したい技術あるメイクアーティスト。" },
        { q: "撮影画像は使用可能？", a: "はい、編集済み画像をクレジット付きで提供。エディトリアル・限定商用ライセンス付き。" },
        { q: "キットは必要？", a: "プロ用ベーシックキットをご持参ください。特殊製品（クリスタル、ペイント等）はこちらで用意。" },
      ],
    },
  },
};

export const COURSE_PAGE_LIST = Object.entries(COURSE_PAGES).map(([slug, data]) => ({ slug, ...data }));

export const tCourse = {
  back: { es: "← Volver a cursos", en: "← Back to courses", jp: "← コース一覧へ" },
  enroll_cta: { es: "Reservar mi lugar", en: "Reserve my spot", jp: "席を予約する" },
  audience_title: { es: "Para quién es", en: "Who it's for", jp: "対象" },
  curriculum_title: { es: "Lo que aprenderás", en: "What you'll learn", jp: "学べる内容" },
  includes_title: { es: "Qué incluye", en: "What's included", jp: "含まれるもの" },
  gallery_title: { es: "Trabajo de referencia", en: "Reference work", jp: "参考作品" },
  faq_title: { es: "Preguntas frecuentes", en: "Frequently asked questions", jp: "よくあるご質問" },
  related: { es: "Otros cursos", en: "Other courses", jp: "その他のコース" },
  details: {
    duration: { es: "Duración", en: "Duration", jp: "期間" },
    next_date: { es: "Próxima fecha", en: "Next date", jp: "次回開催" },
    spots: { es: "Cupo", en: "Spots", jp: "定員" },
    price: { es: "Inversión", en: "Investment", jp: "受講料" },
  },
  cta_block: {
    es: { title: "Aparta tu lugar.", sub: "Los cupos son limitados (6-8 personas). Reservar con anticipación garantiza tu fecha." },
    en: { title: "Save your spot.", sub: "Spots are limited (6-8 people). Booking ahead guarantees your date." },
    jp: { title: "席を確保しましょう。", sub: "定員6〜8名と限られています。早めの予約で日程を確保。" },
  },
};
